import createReducer from '../../../store/createReducer';
import { normalizeArray } from '../../../utils/reducerUtils';
import {
    TRACK_SELECT,
    FETCH_PROGRAM_REQUEST,
    FETCH_TALKS_SUCCESS,
    FETCH_TIMESLOTS_SUCCESS,
    FETCH_WORKSHOP_TIMESLOTS_SUCCESS
} from '../actions/programActions';
import PROGRAM from '../../../mocks/program';
import WORKSHOP_PROGRAM from '../../../mocks/workshopProgram';
import TALKS from '../../../mocks/talks';

function trackSelect(state, action) {
    return {
        ...state,
        selectedTrack: action.payload
    };
}

function fetchProgramRequest(state) {
    return {
        ...state,
        fetchingProgram: true
    };
}

function fetchTalksSuccess(state, action) {
    return {
        ...state,
        talksById: normalizeArray(action.payload),
        talks: action.payload,
        fetchingProgram: false
    };
}

function fetchTimeslotsSuccess(state, action) {
    return {
        ...state,
        timeSlotsById: normalizeArray(action.payload),
        fetchingProgram: false
    };
}

function fetchWorkshopTimeslotsSuccess(state, action) {
    return {
        ...state,
        workshopTimeSlotsById: normalizeArray(action.payload),
        fetchingProgram: false
    };
}

export const initialState = {
    selectedTrack: 'All',
    talks: TALKS,
    talksById: normalizeArray(TALKS),
    timeSlotsById: normalizeArray(PROGRAM),
    workshopTimeSlotsById: normalizeArray(WORKSHOP_PROGRAM),
    fetchingProgram: false
};

export default createReducer(initialState, {
    [TRACK_SELECT]: trackSelect,
    [FETCH_PROGRAM_REQUEST]: fetchProgramRequest,
    [FETCH_TALKS_SUCCESS]: fetchTalksSuccess,
    [FETCH_TIMESLOTS_SUCCESS]: fetchTimeslotsSuccess,
    [FETCH_WORKSHOP_TIMESLOTS_SUCCESS]: fetchWorkshopTimeslotsSuccess
});
